export default "__VITE_ASSET__BcujmION__"